/* eslint-disable react-hooks/exhaustive-deps */
import { decode } from 'jsonwebtoken';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-use';
import { JWT_REFRESH_TOKEN, JWT_TOKEN } from '../../constants/localStorage';
import { getApplication } from '../../store/actions/application/applicationActions';
import { getCountries } from '../../store/actions/common/commonActions';
import { fetchSettings } from '../../store/actions/settings/settingsActions';
import { INIT_USER_SUCCESS } from '../../store/actions/user/userActionConstants';
import { retrieveFromSessionStorage } from '../helpers/sessionStorageHelper';
import { PAGES } from '../../constants/pages';
import { selectApplication } from '../../store/selectors/applicationSelectors';
import { BASIC_ACCOUNT_UPGRADE_TYPES } from '../constants';
import { IS_UPGRADE_FLOW } from '../../constants/sessionStorage';

export default function useInitHook(history) {
  const dispatch = useDispatch();
  const JwtToken = retrieveFromSessionStorage(JWT_TOKEN);
  const JwtRefreshToken = retrieveFromSessionStorage(JWT_REFRESH_TOKEN);
  const Application = useSelector(selectApplication);
  const { AccountUpgradeType } = Application;
  const isUpgrade =
    AccountUpgradeType === BASIC_ACCOUNT_UPGRADE_TYPES.IN_PROCESS;
  const location = useLocation();
  const currentPath = location.pathname;
  const isUpgradeFlow = retrieveFromSessionStorage(IS_UPGRADE_FLOW);

  useEffect(() => {
    if (currentPath === PAGES.PREPARE_REGISTRATION) {
      return;
    }
    if (!JwtToken || !JwtRefreshToken) {
      return;
    }

    dispatch({
      type: INIT_USER_SUCCESS,
      payload: {
        JwtToken,
        JwtRefreshToken,
      },
    });
  }, [JwtToken, JwtRefreshToken]);

  useEffect(() => {
    if (
      currentPath === PAGES.PREPARE_REGISTRATION ||
      currentPath === PAGES.SECURE_ACCOUNT ||
      currentPath === PAGES.CUSTOMER_EMAIL ||
      currentPath === PAGES.ADDRESS_DONE ||
      ((isUpgrade || isUpgradeFlow) &&
        currentPath.includes(PAGES.CHOOSE_APPLICATION.MAIN))
    ) {
      return;
    }
    if (!JwtToken || !JwtRefreshToken) {
      return;
    }
    const { ApplicationUid } = decode(JwtToken);
    if (
      ApplicationUid &&
      ApplicationUid !== '00000000-0000-0000-0000-000000000000'
    ) {
      dispatch(getApplication({ data: { ApplicationUid } }));
    }
  }, [currentPath]);

  useEffect(() => {
    if (currentPath === PAGES.PREPARE_REGISTRATION) {
      return;
    }

    dispatch(fetchSettings());
  }, []);

  useEffect(() => {
    if (
      (isUpgrade || isUpgradeFlow) &&
      currentPath === PAGES.CHOOSE_APPLICATION.MAIN
    ) {
      return;
    }
    if (currentPath === PAGES.PREPARE_REGISTRATION) {
      return;
    }

    if (
      JwtToken &&
      performance.navigation.type === performance.navigation.TYPE_RELOAD
    ) {
      const { ApplicationUid } = decode(JwtToken);

      if (!ApplicationUid) {
        history.push(PAGES.LOGIN_PATH);
        return;
      }
      if (
        currentPath !== PAGES.LOGIN_PATH &&
        currentPath !== PAGES.CREATE_ACCOUNT
      ) {
        history.push(PAGES.REFRESH_LOADING);
        return;
      }
      history.push(currentPath);
    }
  }, []);

  useEffect(() => {
    if (currentPath === PAGES.PREPARE_REGISTRATION) {
      return;
    }

    dispatch(getCountries());
  }, [JwtToken]);
}
